import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoadingController, ToastController } from '@ionic/angular';
import { Clipboard } from '@capacitor/clipboard';
import { CrudService } from '../../services/crud.service';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.page.html',
  styleUrls: ['./voucher.page.scss'],
  standalone: false,
})
export class VoucherPage implements OnInit {
  voucher: any = null;
  loading = false;
  notFoundMsg: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private crud: CrudService,
    private loadCtrl: LoadingController,
    private toastCtrl: ToastController,
  ) {}

  async ngOnInit() {
    const corridaId = this.route.snapshot.paramMap.get('corridaId');
    if (!corridaId) return;
    this.loading = true;
    const loading = await this.loadCtrl.create({ message: 'Loading voucher...' });
    await loading.present();
    this.crud.getData('corrida/voucher', corridaId).subscribe({
      next: (res: any) => {
        this.voucher = res;
        this.loading = false;
        loading.dismiss();
      },
      error: (err) => {
        this.loading = false;
        this.notFoundMsg = err?.error?.message ?? 'Voucher not available yet.';
        loading.dismiss();
      },
    });
  }

  async share() {
    if (!this.voucher) return;
    const text = this.formatText();
    try {
      await navigator.share({ title: 'Trip voucher', text });
    } catch {
      await Clipboard.write({ string: text });
      const toast = await this.toastCtrl.create({ message: 'Copied to clipboard.', duration: 2000, position: 'bottom' });
      await toast.present();
    }
  }

  async copy() {
    const text = this.formatText();
    await Clipboard.write({ string: text });
    const toast = await this.toastCtrl.create({ message: 'Copied!', duration: 2000, position: 'bottom' });
    await toast.present();
  }

  private formatText(): string {
    const v = this.voucher;
    return [
      `GoSpread Trip Voucher`,
      `Passenger: ${v.nomePassageiro} (${v.celularPassageiro})`,
      `From: ${v.enderecoOrigem}`,
      `To: ${v.enderecoDestino}`,
      v.dataAgendamentoCorrida ? `When: ${new Date(v.dataAgendamentoCorrida).toLocaleString()}` : '',
      v.nomeMotorista ? `Driver: ${v.nomeMotorista} (${v.celularMotorista ?? ''})` : '',
      v.veiculoTipo ? `Vehicle: ${v.veiculoTipo}` : '',
    ].filter(Boolean).join('\n');
  }
}
